import { useState } from "react";
import {
    RecentSearchItem,
    SearchResultGroup,
    SearchResultItem,
} from "../../types";
import { SearchWindow } from "../SearchWindow";
import { useFilteredSearchResults } from "../../util/useFilteredSearchResults";
import * as Analytics from "../../analytics";

// // // //

/**
 * Global Search component for Navbar
 */
export function GlobalSearch(props: {
    groups: SearchResultGroup[];
    loadingSearch: boolean;
    recentSearches?: RecentSearchItem[];
    onSelectSearchResult?: (result: SearchResultItem) => void;
    onClearRecentSearches?: () => void;
    onQueryChange?: (query: string) => void;
}) {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const {
        query,
        setQuery,
        setOpen,
        searchGroupings,
        filteredItems,
        topResults,
    } = useFilteredSearchResults(props);

    return (
        <div
            className={`overflow-hidden rounded-lg border bg-card shadow-xs transition-colors ${
                isSearchOpen ? "" : "hover:bg-background-02"
            }`}
        >
            <SearchWindow
                query={query}
                setQuery={(q) => {
                    setQuery(q);
                    props.onQueryChange?.(q);
                }}
                setOpen={setOpen}
                items={filteredItems}
                groups={searchGroupings}
                topResults={topResults}
                loadingSearch={props.loadingSearch}
                recentSearches={props.recentSearches}
                onClearRecentSearches={props.onClearRecentSearches}
                size="md"
                hideResults
                showInteractionTip
                onOpen={() => {
                    setIsSearchOpen(true);
                    Analytics.trackGlobalSearchOpen();
                }}
                onClose={() => {
                    setIsSearchOpen(false);
                    Analytics.trackGlobalSearchClose();
                }}
                onSelectResult={(result) => {
                    props.onSelectSearchResult?.(result);
                    Analytics.trackGlobalSearchSelectResult({
                        label: result.content.label,
                        href: result.href,
                    });
                }}
            />
        </div>
    );
}
